import styled from "@emotion/styled";
import { MAX_DESKTOP_CONTENT_WIDTH, XS_M } from "constants/vp-sizes";
const MAX_DESKTOP_CONTENT_WIDTH_PX = `${MAX_DESKTOP_CONTENT_WIDTH}px`;
const MAX_MOBILE_CONTENT_WIDTH_PX = `${XS_M}px`;
export const StyledHubspotFormComponent = styled.div`
	margin: ${({ horizontalMargin })=>horizontalMargin ? `0 ${horizontalMargin}` : "auto"};
	max-width: ${({ maxWidth })=>maxWidth};

	.hubspot-contact-form-wrapper {
		.base-form {
			box-shadow: ${({ disableShadow })=>disableShadow && "none"};

			.contact-form-row {
				text-align: left;
			}

			.generic-form-input-component .form-input-wrapper {
				margin-bottom: 24px;
			}
		}
	}

	@media (max-width: ${MAX_DESKTOP_CONTENT_WIDTH_PX}) {
		.base-form .contact-form-row {
			flex-direction: unset;
		}
	}

	@media (max-width: ${MAX_MOBILE_CONTENT_WIDTH_PX}) {
		.base-form {
			padding-left: ${({ mobileHorizontalPadding })=>mobileHorizontalPadding};
			padding-right: ${({ mobileHorizontalPadding })=>mobileHorizontalPadding};

			.contact-form-row .form-input-wrapper {
				font-size: 0.8125rem;
			}
		}
	}

	${({ singleLineFieldBreakpoint })=>singleLineFieldBreakpoint ? `
        @media (max-width: ${singleLineFieldBreakpoint}px) {
          .base-form .contact-form-row {
            flex-direction: column;
            align-items: baseline;

            .form-input-wrapper {
              width: 100%;
            }
          }
        }
      ` : ""}
`;
